import { ActivatedRouteSnapshot, Data } from '@angular/router';

import { HelpTopicId, isHelpTopicId, RouteHelpTopicId } from './help-topic.model';

export interface HelpRouteData extends Data {
  helpTopic: RouteHelpTopicId;
}

export function helpRouteData(helpTopic: RouteHelpTopicId): HelpRouteData {
  return { helpTopic };
}

function getFirstChild(snapshot: ActivatedRouteSnapshot): ActivatedRouteSnapshot | null {
  const ownFirstChild = Object.getOwnPropertyDescriptor(snapshot, 'firstChild');
  if (ownFirstChild && 'value' in ownFirstChild) {
    return ownFirstChild.value as ActivatedRouteSnapshot | null;
  }

  try {
    return snapshot.firstChild;
  } catch {
    return null;
  }
}

export function getDeepestHelpTopic(snapshot: ActivatedRouteSnapshot): HelpTopicId | null {
  let current: ActivatedRouteSnapshot | null = snapshot;
  let topic: HelpTopicId | null = null;

  while (current) {
    const candidate = current.data['helpTopic'];
    if (isHelpTopicId(candidate)) {
      topic = candidate;
    }
    current = getFirstChild(current);
  }

  return topic;
}
